import api from './api';
import { ImportResult, ImportLog, PaginationInfo } from '../types';

export const adminService = {
    // Import products from CSV
    importProducts: async (file: File): Promise<ImportResult> => {
        const formData = new FormData();
        formData.append('csvFile', file);

        const response = await api.post('/admin/products/import', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data;
    },

    // Get import history
    getImportHistory: async (page: number = 1, limit: number = 10): Promise<{
        imports: ImportLog[];
        pagination: PaginationInfo;
    }> => {
        const response = await api.get(`/admin/imports/history?page=${page}&limit=${limit}`);
        return response.data;
    },

    // Get all users (admin)
    getAllUsers: async (): Promise<{ users: any[] }> => {
        const response = await api.get('/admin/users');
        return response.data;
    },

    // Get pending registrations (admin)
    getPendingRegistrations: async (): Promise<{ users: any[] }> => {
        const response = await api.get('/auth/pending-registrations');
        return response.data;
    },

    // Get pending registrations count (admin)
    getPendingRegistrationsCount: async (): Promise<{ count: number }> => {
        const response = await api.get('/auth/pending-registrations-count');
        return response.data;
    },

    // Approve registration (admin)
    approveRegistration: async (userId: number): Promise<any> => {
        const response = await api.post(`/auth/approve-registration/${userId}`);
        return response.data;
    },

    // Reject registration (admin)
    rejectRegistration: async (userId: number): Promise<any> => {
        const response = await api.post(`/auth/reject-registration/${userId}`);
        return response.data;
    },
};
